import React from 'react'
import { View, Text, ScrollView, Platform, StyleSheet } from 'react-native'

interface DiagnosticsBoundaryProps {
  children: React.ReactNode
  name?: string
}

interface DiagnosticsBoundaryState {
  error: any
  info: any
  ts: number | null
}

/**
 * ErrorBoundary simple para capturar excepciones de render que en web estaban dejando la pantalla en blanco.
 * Muestra un panel con detalles básicos y stack. No se incluye en producción.
 */
export class DiagnosticsBoundary extends React.Component<DiagnosticsBoundaryProps, DiagnosticsBoundaryState> {
  constructor(props: DiagnosticsBoundaryProps) {
    super(props)
    this.state = { error: null, info: null, ts: null }
  }
  static getDerivedStateFromError(error: any) {
    return { error, ts: Date.now() }
  }
  componentDidCatch(error: any, info: any) {
    this.setState({ info })
    try {
      // Log estructurado
      console.error('[DiagnosticsBoundary] capture', { name: this.props.name, error: error?.message, stack: error?.stack, info })
    } catch {}
  }
  render() {
    if (this.state.error && __DEV__) {
      return (
        <ScrollView style={styles.wrapper} contentContainerStyle={styles.inner}>
          <Text style={styles.title}>⚠️ Error de Render</Text>
          <Text style={styles.label}>Boundary:</Text>
          <Text style={styles.code}>{this.props.name || 'root'}</Text>
          <Text style={styles.label}>Mensaje:</Text>
            <Text style={styles.msg}>{String(this.state.error?.message || this.state.error)}</Text>
          <Text style={styles.label}>Stack:</Text>
          <Text selectable style={styles.stack}>{this.state.error?.stack || 'No stack'}</Text>
          {this.state.info && (
            <>
              <Text style={styles.label}>Component Stack:</Text>
              <Text selectable style={styles.stack}>{this.state.info?.componentStack}</Text>
            </>
          )}
          <Text style={styles.footer}>Se capturó un error que probablemente causaba la pantalla en blanco. Revisa consola para más detalles.</Text>
        </ScrollView>
      )
    }
    return this.props.children as any
  }
}

export const withDiagnosticsBoundary = (Comp: React.ComponentType<any>, name?: string) => (props: any) => (
  <DiagnosticsBoundary name={name}><Comp {...props} /></DiagnosticsBoundary>
)

const styles = StyleSheet.create({
  wrapper: { flex: 1, backgroundColor: '#111', padding: 12 },
  inner: { paddingBottom: 120 },
  title: { fontSize: 20, fontWeight: '700', color: '#fff', marginBottom: 12 },
  label: { marginTop: 12, fontWeight: '600', color: '#ccc' },
  code: { fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace', color: '#8ab4ff', marginTop: 2 },
  msg: { color: '#f88', marginTop: 4, fontWeight: '500' },
  stack: { marginTop: 4, fontFamily: Platform.OS === 'ios' ? 'Courier' : 'monospace', fontSize: 12, color: '#ddd' },
  footer: { marginTop: 24, color: '#999', fontSize: 12 },
})

export default DiagnosticsBoundary
